import { render, staticRenderFns } from "./ComboMotivoFechamento.vue?vue&type=template&id=53fc56d7"
import script from "./ComboMotivoFechamento.vue?vue&type=script&lang=ts"
export * from "./ComboMotivoFechamento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports